import getOfficeUndergrounds from './getOfficeUndergrounds'; // TODO: Сейчас забито гвоздями в месте получения маршрута
import getOfficeSchedule from './getOfficeSchedule'; // TODO: Сейчас забито гвоздями возвращение первой записи
import getOfficePhone from './getOfficePhone'; // TODO: Сделать нормальную маску
import getOfficeArea from './getOfficeArea';
import getClosestOffices from './getClosestOffices';
import getOfficeAuxiliary from './getOfficeAuxiliary';

const tryGet = (func, currentOffice, defaultValue = null, ...options) => {
  // TODO: избавиться от try/catch
  try {
    return func(currentOffice, ...options);
  } catch (e) {
    return defaultValue;
  }
};

const getOfficeById = (offices, officeId, additionalData) => {
  const currentOffice = offices.find(office => office.id === officeId);

  return {
    id: officeId,
    name: currentOffice.name,
    rating: currentOffice.rating,
    isVirtual: currentOffice.isVirtual,
    translation: currentOffice.camerasUrl,
    description: currentOffice.description,
    address: currentOffice.address,
    status: currentOffice.status,
    auxiliaryServicesIds: currentOffice.auxiliaryServicesIds,
    auxiliaryList: getOfficeAuxiliary(
      currentOffice.auxiliaryServicesIds,
      additionalData.auxiliary
    ),
    services: currentOffice.services,
    servicesInOffice: currentOffice.servicesInOffice,
    bookableServicesIds: currentOffice.bookableServicesIds,
    type: currentOffice.type,
    replacementOffice: currentOffice.replacementOffice,
    nearOffices: getClosestOffices(currentOffice, offices),

    area: tryGet(getOfficeArea, currentOffice, '', additionalData.areas),
    undergrounds: tryGet(
      getOfficeUndergrounds,
      currentOffice,
      [],
      additionalData.undergrounds
    ),
    schedule: tryGet(
      getOfficeSchedule,
      currentOffice,
      {},
      additionalData.schedules
    ),
    phone: tryGet(getOfficePhone, currentOffice),
  };
};

export default getOfficeById;
